<script>
import { EventBus } from "../../hermeneus.eventbus/eventbus.js";

export default {
  name: "uebungen-library-create-uebung",
  data() {
    return {
      hoveredCategory: null,
      hoveredLudusCursus: false,
    }
  },
  methods: {
    createVokabelAbfrage() {
      EventBus.$emit('uebungen-library__load-component-in-modal', {
        component_alias: 'vokabel-abfrage-create-component',
        component_title: 'Vokabelabfrage',
        component_icon: "hi-uebung-vokabelabfrage",
      });
    },
    selectUebung(uebung) {

      EventBus.$emit('uebungen-library__load-component-in-modal', {
        component_alias: uebung.components.create.alias,
        component_title: uebung.components.create.title,
        component_icon: "hi-uebungen-new",
      });
    },
  },
  computed: {
    registeredCategories() {
      return this.$UebungenRegistry.registered_categories;
    },
    registeredUebungen() {
      return this.$UebungenRegistry.registered_uebungen;
    },
    /**
     * Gibt die Kategorien mit den Uebungen zurueck,
     * filtert aber Uebungen heraus, die is_creatable: false haben.
     */
    registeredUebungenByCategories() {
      return this.$UebungenRegistry.registered_uebungen_by_category.map(category => {
        return {
          ...category,
          uebungen: category.uebungen.filter(uebung => {
            // Nur Uebungen anzeigen, die is_creatable nicht explizit auf false gesetzt haben
            return uebung.options?.is_creatable !== false;
          })
        };
      });
    },
  },
}
</script>

<template>
  <div class="uebungen-library__create-uebung p-6 flex flex-row justify-evenly">
    <div class="uebungen-library__create-uebung__bg-container">
      <img src="/img/svg/discipulus-ipad.svg" alt="" class="uebungen-library__create-uebung__bg">
    </div>
    <div v-for="category in registeredUebungenByCategories"
      :key="category.alias"
      class="mt-12"
      :class="['uebungen-library__create-uebung__category-card-container', category.alias === 'uebung-vocab' ? 'uebungen-library__create-uebung__category-card-container--wide' : '']"
      @mouseenter="hoveredCategory = category.alias" @mouseleave="hoveredCategory = null">
      <div :class="{ 'is-hovered': hoveredCategory === category.alias, 'uebungen-library__create-uebung__category-card--wide': category.alias === 'uebung-vocab' }"
        class="uebungen-library__create-uebung__category-card cursor-pointer flex flex-row border-4 border-white rounded-xl shadow-xl overflow-hidden hover:shadow-2xl transition-all relative">
        <button
          @click="this.$emit('uebungen-library__set-active-step', `uebungen-library-category-${category.alias}-create`)"
          class="uebungen-library__create-uebung__btn flex flex-col  items-center text-white leading-relaxed   transition-all relative"
          :disabled="!category.is_enabled">

          <div class="header flex flex-col items-center justify-center w-full relative  pointer-events-none">
            <div class="flex flex-row justify-center w-full  p-6">
              <hermeneus-icon v-if="hoveredCategory === category.alias" height="112" width="112"
                :name="`hi-tc-uebung-category-${category.alias}`" :preserve-colors="true" class="z-10"></hermeneus-icon>
              <hermeneus-icon v-else height="112" width="112" :name="`hi-uebung-category-${category.alias}`"
                color="current" class="z-10"></hermeneus-icon>
            </div>
          </div>
          <h2 class="text-4xl leading-normal uppercase text-center font-bold p-6">{{ category.title }}</h2>
          <div class="uebungen-library__create-uebung__btn__desc text-xl leading-relaxed px-6">{{ category.description }}</div>

          <div v-if="category.alias==='uebung-vocab'" class="uebungen-library__create-uebung__vokabelabfrage text-sm w-full text-white p-3 mt-6">
            <button @click="createVokabelAbfrage" class="uebung-item w-full flex flex-row justify-start items-start text-primary-400 hover:text-primary-200 p-4 mt-2 rounded bg-transparent hover:bg-primary-900/50 ring-1 ring-primary-400/50 text-xl transition-all">
              <div class="w-18">
                <hermeneus-icon height="48" width="48" name="hi-uebung-vokabelabfrage" color="current" class="mr-4"></hermeneus-icon>
              </div>
              <div class="flex flex-col justify-start items-start">
                <div class="text-xl font-bold">Vokabelabfrage</div>
                <div class="text-sm text-left uebungen-library__create-uebung__uebung-desc">Eine Abfrage aus verschiedenen Vokabel-Übungen erstellen</div>
              </div>
            </button>
          </div>
          <div v-if="category.alias==='uebung-ludus'" class="text-sm w-full text-white p-3 mt-6">
            <div v-for="uebung in category.uebungen"
              @click="selectUebung(registeredUebungen['uebung-ludus-cursus'])"
              @mouseenter="hoveredLudusCursus = true"
              @mouseleave="hoveredLudusCursus = false"
              class="uebung-item cursor-pointer flex flex-col justify-center items-center bg-primary-900 hover:bg-primary-200 p-4 mt-2 rounded text-primary-400 hover:text-primary-800 text-xl transition-all">
              <div class="w-18">
                <hermeneus-icon
                  height="160" width="160"
                  name="hi-ludus-cursus"
                  :preserve-colors="hoveredLudusCursus"
                  color="current"
                  class="mr-4"></hermeneus-icon>
              </div>
              <div class="flex flex-col justify-center items-center">
                <div class="font-bold text-3xl mt-3">
                  {{ uebung.title }}
                </div>
                <div class="text-base text-center mt-2 uebungen-library__create-uebung__uebung-desc">{{ uebung.description }}</div>
              </div>
            </div>
          </div>
          <div v-else class="text-sm w-full text-white p-3" :class="{'mt-6': category.alias!=='uebung-vocab', 'grid grid-cols-2 gap-2': category.alias==='uebung-vocab'}">
            <button v-for="uebung in category.uebungen"
            :class="{'hidden-vokabel-abfrage': uebung.alias==='vokabel-abfrage', 'mt-2': category.alias !== 'uebung-vocab'}"
              class="uebung-item flex flex-row justify-start items-start bg-primary-900 hover:bg-primary-800 p-4 rounded text-primary-400 hover:text-primary-200 text-xl transition-all">
              <div class="w-18">

                <hermeneus-icon height="48" width="48" :name="`${uebung.appearance.icon}`" color="current"
                  class="mr-4"></hermeneus-icon>
              </div>
              <div @click="selectUebung(uebung)" class="flex flex-col justify-start items-start">
                <div class="font-bold text-left">
                  {{ uebung.title }}
                </div>
                <div class="text-sm text-left uebungen-library__create-uebung__uebung-desc">{{ uebung.description }}</div>
              </div>
            </button>
          </div>

        </button>
      </div>

    </div>
  </div>

</template>

<style scoped>
.hidden-vokabel-abfrage{
  display: none;
}
.uebungen-library__create-uebung__category-card {
  width: 24rem;
  overflow: hidden;
  position: relative;
}

.uebungen-library__create-uebung__category-card.is-hovered {
}

.uebungen-library__create-uebung__category-card-container {
  animation: popIn 0.5s ease-in-out forwards;
  opacity: 0;
  width: 24rem;
}

.uebungen-library__create-uebung__category-card-container--wide {
  width: 40rem;
}

.uebungen-library__create-uebung__category-card--wide {
  width: 40rem;
}

@keyframes popIn {
  0% {
    opacity: 0;
    transform: scale(0.3);
  }

  70% {
    transform: scale(1.1);
  }

  100% {
    opacity: 1;
    transform: scale(1);
  }
}

/* Animation-Delay für jede Karte */
/* Hintergrundbild ist das erste Kind, daher beginnen die Karten bei nth-child(2) */
.uebungen-library__create-uebung__category-card-container:nth-child(2) {
  animation-delay: 2.5s;
}

.uebungen-library__create-uebung__category-card-container:nth-child(3) {
  animation-delay: 2.7s;
}

.uebungen-library__create-uebung__category-card-container:nth-child(4) {
  animation-delay: 2.9s;
}

/* Animation für das Hintergrundbild */
.uebungen-library__create-uebung {
  position: relative;
  min-height: 100vh;
}

.uebungen-library__create-uebung__bg-container {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: -1;
  pointer-events: none;
  display: flex;
  justify-content: center;
}

.uebungen-library__create-uebung__bg {
  animation: fadeInTransparent 2s ease-in-out;
  opacity: 0;
  animation-fill-mode: forwards;
  max-width: 100%;
  height: auto;
  vertical-align: bottom;
}

@keyframes fadeInTransparent {
  from {
    opacity: 0;
    transform: translateY(10px);
  }

  to {
    opacity: 0.3;
    transform: translateY(0);
  }
}


.uebungen-library__create-uebung__category-card::before {
  content: '';
  position: absolute;
  inset: 0;
  background-image: linear-gradient(15deg,
      hsl(232deg 23% 13%) 0%,
      hsl(232deg 23% 13%) 4%,
      hsl(232deg 23% 14%) 9%,
      hsl(232deg 23% 15%) 13%,
      hsl(232deg 23% 15%) 18%,
      hsl(232deg 23% 16%) 22%,
      hsl(232deg 23% 16%) 28%,
      hsl(232deg 23% 17%) 34%,
      hsl(232deg 23% 18%) 40%,
      hsl(232deg 23% 18%) 49%,
      hsl(232deg 23% 19%) 60%,
      hsl(232deg 23% 20%) 75%,
      hsl(233deg 23% 20%) 100%);
  z-index: 1;
}

/* Hover-Gradient */
.uebungen-library__create-uebung__category-card::after {
  content: '';
  position: absolute;
  inset: 0;
  background-image: linear-gradient(35deg,
      hsl(232deg 23% 13%) 0%,
      hsl(232deg 23% 14%) 10%,
      hsl(232deg 23% 15%) 18%,
      hsl(232deg 23% 16%) 26%,
      hsl(232deg 23% 18%) 34%,
      hsl(232deg 23% 19%) 42%,
      hsl(233deg 23% 20%) 50%,
      hsl(261deg 25% 24%) 58%,
      hsl(292deg 29% 25%) 65%,
      hsl(319deg 42% 27%) 73%,
      hsl(334deg 54% 31%) 82%,
      hsl(345deg 61% 34%) 90%,
      hsl(359deg 59% 37%) 100%);
  opacity: 0;
  transition: opacity 0.4s ease-in-out;
  z-index: 2;
}

.uebungen-library__create-uebung__category-card:hover::after {
  opacity: 1;
}


.uebungen-library__create-uebung__btn::before {
  content: '';
  position: absolute;
  top: -26rem;
  left: -10%;
  right: -10%;
  height: 40rem;
  background-image: linear-gradient(to bottom,
      rgb(255, 255, 255) 0%,
      rgb(255, 255, 255) 50%,
      rgba(255, 255, 255, 0.55) 100%);
  border-radius: 0 0 50% 50%;
  z-index: 3;
  opacity: 0;
  transform: translateY(-20%) scale(0.8);
  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
}

.uebungen-library__create-uebung__category-card.is-hovered .uebungen-library__create-uebung__btn::before {
  opacity: 1;
  transform: translateY(0) scale(1);
}

.uebungen-library__create-uebung__btn {
  width: 100%;
  height: 100%;
  position: relative;
  z-index: 3;
}


.uebungen-library__create-uebung__btn .uebungen-library__create-uebung__btn__desc {
  transition: opacity 0.5s;
}

.uebungen-library__create-uebung__uebung-desc {
  opacity: 0;
  max-height: 0;
  overflow: hidden;
  transition: opacity 0.3s, max-height 0.3s;
}

.uebung-item:hover .uebungen-library__create-uebung__uebung-desc {
  opacity: 1;
  max-height: 10rem;
}

</style>